import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const RiskIcon = forwardRef<SVGSVGElement, IconProps>(function RiskIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.51183 13.0759C3.85789 13.0066 4.19565 13.2259 4.26623 13.5657C4.99948 17.0958 8.1778 19.7442 11.9957 19.7442C15.7962 19.7442 18.968 17.1041 19.7174 13.5877C19.7897 13.2482 20.1286 13.0306 20.4743 13.1017C20.82 13.1727 21.0416 13.5054 20.9693 13.8449C20.0986 17.9302 16.415 21 11.9957 21C7.5599 21 3.86573 17.9218 3.01303 13.8166C2.94245 13.4768 3.16577 13.1452 3.51183 13.0759Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.01335 10.1818C3.87482 6.08751 7.56718 3 11.9957 3C16.4507 3 20.1628 6.11435 20.988 10.2552C21.0558 10.5956 20.8298 10.9254 20.4832 10.992C20.1366 11.0586 19.8006 10.8367 19.7328 10.4964C19.0231 6.93494 15.8287 4.25581 11.9957 4.25581C8.18756 4.25581 5.00744 6.91158 4.2659 10.4359C4.19444 10.7755 3.85612 10.9939 3.51024 10.9238C3.16436 10.8536 2.9419 10.5214 3.01335 10.1818Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9957 11.3721C11.6426 11.3721 11.3562 11.6532 11.3562 12C11.3562 12.3468 11.6426 12.6279 11.9957 12.6279C12.3489 12.6279 12.6352 12.3468 12.6352 12C12.6352 11.6532 12.3489 11.3721 11.9957 11.3721ZM10.0772 12C10.0772 10.9596 10.9362 10.1163 11.9957 10.1163C13.0553 10.1163 13.9142 10.9596 13.9142 12C13.9142 13.0403 13.0553 13.8837 11.9957 13.8837C10.9362 13.8837 10.0772 13.0403 10.0772 12Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M11.5694 5.77326C11.5694 5.51317 11.8557 5.30233 12.2089 5.30233C12.5621 5.30233 12.8484 5.51317 12.8484 5.77326V7.34302C12.8484 7.60311 12.5621 7.81395 12.2089 7.81395C11.8557 7.81395 11.5694 7.60311 11.5694 7.34302V5.77326Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M18.5506 11.3721C18.8155 11.3721 19.0302 11.6532 19.0302 12C19.0302 12.3468 18.8155 12.6279 18.5506 12.6279H16.9519C16.687 12.6279 16.4722 12.3468 16.4722 12C16.4722 11.6532 16.687 11.3721 16.9519 11.3721H18.5506Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M11.5694 16.657C11.5694 16.3969 11.8557 16.186 12.2089 16.186C12.5621 16.186 12.8484 16.3969 12.8484 16.657V18.2267C12.8484 18.4868 12.5621 18.6977 12.2089 18.6977C11.8557 18.6977 11.5694 18.4868 11.5694 18.2267V16.657Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M7.46596 11.3721C7.73085 11.3721 7.94559 11.6532 7.94559 12C7.94559 12.3468 7.73085 12.6279 7.46596 12.6279H5.86722C5.60233 12.6279 5.38759 12.3468 5.38759 12C5.38759 11.6532 5.60233 11.3721 5.86722 11.3721H7.46596Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
